import { Env, ModelNames, ProductNames } from './constants/exports';

const config = new Object();

config[Env.DEVELOP] = {
	theme: {
		palette: {
			primary: {
				main: '#D13438',
			},
		},
	},
	amplify: {
		Auth: {
			identityPoolId: 'ap-northeast-1:4fe8d94e-8656-4886-a87a-bc2a41db0228',
			region: "ap-northeast-1",
			userPoolId: "ap-northeast-1_Ca9VgTmXl",
			userPoolWebClientId: "5csii105v3sn0goged2n5josme",
		},
		Storage: {
			AWSS3: {
				bucket: 'dev-tapi-storage',
				region: "us-west-1",
			},
		},
	},
	tapi: {
		endpoint: 'https://hwy8wash2k.execute-api.us-west-1.amazonaws.com/dev',
	},
	permissions: {
         // PT-750などの決済端末
		'payterm': [
			{type: 'product_name', value: ProductNames.IM_A820.value},
			{type: 'model_name', value: ModelNames.PT_750_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_750_HOUSE_APP.value},
			{type: 'model_name', value: ModelNames.PT_750_VALUEDESIGN_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_750_PREPAID_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_750_T9830_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_750_T9310_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_750_VALUEDESIGN_T9830_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_750_VALUEDESIGN_T9310_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_750_PREPAID_T9830_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_750_PREPAID_T9310_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_750_TERMINAL_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_750_TERMINAL_MAINTENANCE_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_751_TOYOTA_T9830_DEBUG.value},
			{type: 'model_name', value: ModelNames.PAYMENT_TERMINAL_MANAGER_DEBUG.value},
			{type: 'model_name', value: ModelNames.PAYMENT_TERMINAL_DUMMY_DEBUG.value},
			{type: 'model_name', value: ModelNames.PAYMENT_TERMINAL_SET_DEFAULT_TYPE_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_751_TAXI_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_751_TAXI_FUTABAD_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_751_TAXI_YAZAKID_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_751_TAXI_OKABED_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_751_POS_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_630_POS_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_751_VALUEDESIGN_POS_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_750_MODEM_CHECKER_DEBUG.value},
			{type: 'model_name', value: ModelNames.NEWPOS_MBN_MANAGER_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_751_VALUEDESIGN_TEMPLE_DEBUG.value},
		],
         // 横浜敬老パス端末
		'businvterm': [
			{type: 'model_name', value: ModelNames.YOKOHAMA_SENIOR_PASS_PORTABLE_DEBUG.value},
			{type: 'model_name', value: ModelNames.YOKOHAMA_SENIOR_PASS_PORTABLE.value},
			{type: 'model_name', value: ModelNames.YOKOHAMA_SENIOR_PASS_ADMIN_PORTABLE_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_750_MODEM_CHECKER_DEBUG.value},
		],
		// タブレットナビ
		'tapp': [
			{type: 'product_name', value: ProductNames.IM_A820.value},
			{type: 'model_name', value: ModelNames.TAPP_DEV.value},
			{type: 'model_name', value: ModelNames.RAKU2_DRIVER_APP_DEV.value},
			{type: 'model_name', value: ModelNames.RAKU2_DRIVER_APP.value},
			{type: 'model_name', value: ModelNames.RAKU2_DRIVER_BUSINESS.value},
		],
		// ABT/トランジット
		'abt': [
			{type: 'model_name', value: ModelNames.PT_850.value},
			{type: 'model_name', value: ModelNames.ABT_TABLET_DEBUG.value},
		],
		// ワンタブ DiDi社アカウント
		'didi': [
			{type: 'model_name', value: ModelNames.DIDI.value},
		],
		// ワンタブ S.RIDE社アカウント
		'sride': [
			{type: 'model_name', value: ModelNames.SRIDE.value},
			{type: 'model_name', value: ModelNames.SRIDE_DEV.value},
		],
		// ワンタブ Uber社アカウント
		'uber': [
			{type: 'model_name', value: ModelNames.UBER_CAB.value},
		],
		// ワンタブ Rea社アカウント
		'onetab-rea': [
			{type: 'model_name', value: ModelNames.ONETAB_REA.value},
		],
		// ワンタブ バスチケ
		'bus-ticket': [
			{type: 'model_name', value: ModelNames.BUS_TICKET_DEBUG.value},
			{type: 'product_name', value: ProductNames.PT_830.value},
		],
		// AxsysOneアカウント
		'axsysone': [
			{type: 'model_name', value: ModelNames.AXSYSONE.value},
		],
	},
};

config[Env.STAGING] = {
	theme: {
	},
	amplify: {
		Auth: {
			identityPoolId: 'ap-northeast-1:4fe8d94e-8656-4886-a87a-bc2a41db0228',
			region: "ap-northeast-1",
			userPoolId: "ap-northeast-1_Ca9VgTmXl",
			userPoolWebClientId: "5csii105v3sn0goged2n5josme",
		},
		Storage: {
			AWSS3: {
				bucket: 'stg-tapi-storage',
				region: "us-west-1",
			},
		},
	},
	tapi: {
		endpoint: 'https://4bjunvkw5a.execute-api.us-west-1.amazonaws.com/stg',
	},
	permissions: {
         // PT-750などの決済端末
		'payterm': [
			{type: 'product_name', value: ProductNames.IM_A820.value},
			{type: 'model_name', value: ModelNames.PT_750_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_750_HOUSE_APP.value},
			{type: 'model_name', value: ModelNames.PT_750_VALUEDESIGN_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_750_PREPAID_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_750_T9830_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_750_T9310_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_750_VALUEDESIGN_T9830_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_750_VALUEDESIGN_T9310_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_750_PREPAID_T9830_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_750_PREPAID_T9310_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_750_TERMINAL_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_750_TERMINAL_MAINTENANCE_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_751_TOYOTA_T9830_DEBUG.value},
			{type: 'model_name', value: ModelNames.PAYMENT_TERMINAL_MANAGER_DEBUG.value},
			{type: 'model_name', value: ModelNames.PAYMENT_TERMINAL_DUMMY_DEBUG.value},
			{type: 'model_name', value: ModelNames.PAYMENT_TERMINAL_SET_DEFAULT_TYPE_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_751_TAXI_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_751_TAXI_FUTABAD_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_751_TAXI_YAZAKID_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_751_TAXI_OKABED_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_751_POS_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_630_POS_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_751_VALUEDESIGN_POS_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_750_MODEM_CHECKER_DEBUG.value},
			{type: 'model_name', value: ModelNames.NEWPOS_MBN_MANAGER_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_751_VALUEDESIGN_TEMPLE_DEBUG.value},
		],
         // 横浜敬老パス端末
		'businvterm': [
			{type: 'model_name', value: ModelNames.YOKOHAMA_SENIOR_PASS_PORTABLE_DEBUG.value},
			{type: 'model_name', value: ModelNames.YOKOHAMA_SENIOR_PASS_PORTABLE.value},
			{type: 'model_name', value: ModelNames.YOKOHAMA_SENIOR_PASS_ADMIN_PORTABLE_DEBUG.value},
			{type: 'model_name', value: ModelNames.PT_750_MODEM_CHECKER_DEBUG.value},
		],
		// タブレットナビ
		'tapp': [
			{type: 'product_name', value: ProductNames.IM_A820.value},
			{type: 'model_name', value: ModelNames.TAPP_STG.value},
			{type: 'model_name', value: ModelNames.RAKU2_DRIVER_APP_STG.value},
			{type: 'model_name', value: ModelNames.RAKU2_DRIVER_APP.value},
			{type: 'model_name', value: ModelNames.RAKU2_DRIVER_BUSINESS.value},
		],
		// ABT/トランジット
		'abt': [
			{type: 'model_name', value: ModelNames.PT_850.value},
			{type: 'model_name', value: ModelNames.ABT_TABLET_DEBUG.value},
		],
		// ワンタブ DiDi社アカウント
		'didi': [
			{type: 'model_name', value: ModelNames.DIDI.value},
		],
		// ワンタブ S.RIDE社アカウント
		'sride': [
			{type: 'model_name', value: ModelNames.SRIDE.value},
			{type: 'model_name', value: ModelNames.SRIDE_DEV.value},
		],
		// ワンタブ Uber社アカウント
		'uber': [
			{type: 'model_name', value: ModelNames.UBER_CAB.value},
		],
		// ワンタブ Rea社アカウント
		'onetab-rea': [
			{type: 'model_name', value: ModelNames.ONETAB_REA.value},
		],
		// ワンタブ バスチケ
		'bus-ticket': [
			{type: 'model_name', value: ModelNames.BUS_TICKET_DEBUG.value},
			{type: 'product_name', value: ProductNames.PT_830.value},
		],
		// AxsysOneアカウント
		'axsysone': [
			{type: 'model_name', value: ModelNames.AXSYSONE.value},
		],
	},
};

config[Env.PRODUCTION] = {
	theme: {
		palette: {
			primary: {
				main: '#000',
			},
		},
	},
	amplify: {
		Auth: {
			identityPoolId: 'ap-northeast-1:2c9556ad-8a11-45c8-bccc-2dcfb71c2147',
			region: "ap-northeast-1",
			userPoolId: "ap-northeast-1_97HZyfK38",
			userPoolWebClientId: "2cmimjoht68f5qon8msg9vamjl",
		},
		Storage: {
			AWSS3: {
				bucket: 'tapi-storage',
				region: "ap-northeast-1",
			},
		},
	},
	tapi: {
		endpoint: 'https://wrmh3avp17.execute-api.ap-northeast-1.amazonaws.com/prod',
	},
	permissions: {
         // PT-750などの決済端末
		'payterm': [
			{type: 'product_name', value: ProductNames.IM_A820.value},
			{type: 'model_name', value: ModelNames.PT_750.value},
			{type: 'model_name', value: ModelNames.PT_750_VALUEDESIGN.value},
			{type: 'model_name', value: ModelNames.PT_750_PREPAID.value},
			{type: 'model_name', value: ModelNames.PT_750_T9830.value},
			{type: 'model_name', value: ModelNames.PT_750_T9310.value},
			{type: 'model_name', value: ModelNames.PT_750_VALUEDESIGN_T9830.value},
			{type: 'model_name', value: ModelNames.PT_750_VALUEDESIGN_T9310.value},
			{type: 'model_name', value: ModelNames.PT_750_PREPAID_T9830.value},
			{type: 'model_name', value: ModelNames.PT_750_PREPAID_T9310.value},
			{type: 'model_name', value: ModelNames.PT_750_TERMINAL.value},
			{type: 'model_name', value: ModelNames.PT_750_TERMINAL_MAINTENANCE.value},
			{type: 'model_name', value: ModelNames.PT_751_TOYOTA_T9830.value},
			{type: 'model_name', value: ModelNames.PAYMENT_TERMINAL_MANAGER.value},
			{type: 'model_name', value: ModelNames.PAYMENT_TERMINAL_DUMMY.value},
			{type: 'model_name', value: ModelNames.PAYMENT_TERMINAL_SET_DEFAULT_TYPE.value},
			{type: 'model_name', value: ModelNames.PT_751_TAXI.value},
			{type: 'model_name', value: ModelNames.PT_751_TAXI_FUTABAD.value},
			{type: 'model_name', value: ModelNames.PT_751_TAXI_YAZAKID.value},
			{type: 'model_name', value: ModelNames.PT_751_TAXI_OKABED.value},
			{type: 'model_name', value: ModelNames.PT_751_POS.value},
			{type: 'model_name', value: ModelNames.PT_630_POS.value},
			{type: 'model_name', value: ModelNames.PT_751_VALUEDESIGN_POS.value},
			{type: 'model_name', value: ModelNames.PT_750_MODEM_CHECKER.value},
			{type: 'model_name', value: ModelNames.NEWPOS_MBN_MANAGER.value},
			{type: 'model_name', value: ModelNames.PT_751_VALUEDESIGN_TEMPLE.value},
		],
         // 横浜敬老パス端末
		'businvterm': [
			{type: 'model_name', value: ModelNames.YOKOHAMA_SENIOR_PASS_PORTABLE.value},
			{type: 'model_name', value: ModelNames.YOKOHAMA_SENIOR_PASS_ADMIN_PORTABLE.value},
			{type: 'model_name', value: ModelNames.PT_750_MODEM_CHECKER.value},
		],
		// タブレットナビ
		'tapp': [
			{type: 'product_name', value: ProductNames.IM_A820.value},
			{type: 'model_name', value: ModelNames.TAPP.value},
			{type: 'model_name', value: ModelNames.RAKU2_DRIVER_APP.value},
		],
		// ABT/トランジット
		'abt': [
			{type: 'model_name', value: ModelNames.PT_850.value},
			{type: 'model_name', value: ModelNames.ABT_TABLET.value},
		],
		// ワンタブ DiDi社アカウント
		'didi': [
			{type: 'model_name', value: ModelNames.DIDI.value},
		],
		// ワンタブ S.RIDE社アカウント
		'sride': [
			{type: 'model_name', value: ModelNames.SRIDE.value},
			{type: 'model_name', value: ModelNames.SRIDE_DEV.value},
		],
		// ワンタブ Uber社アカウント
		'uber': [
			{type: 'model_name', value: ModelNames.UBER_CAB.value},
		],
		// ワンタブ Rea社アカウント
		'onetab-rea': [
			{type: 'model_name', value: ModelNames.ONETAB_REA.value},
		],
		// ワンタブ バスチケ
		'bus-ticket': [
			{type: 'model_name', value: ModelNames.BUS_TICKET.value},
			{type: 'product_name', value: ProductNames.PT_830.value},
		],
		// AxsysOneアカウント
		'axsysone': [
			{type: 'model_name', value: ModelNames.AXSYSONE.value},
		],
	},
};

export default deepFreeze(config);

function deepFreeze(object) {
	// オブジェクトで定義されたプロパティ名を取得
	const propNames = Object.getOwnPropertyNames(object);

	// 自分自身を凍結する前にプロパティを凍結

	for (const name of propNames) {
		const value = object[name];

		if (value && typeof value === "object") {
			deepFreeze(value);
		}
	}

	return Object.freeze(object);
}
